import $ from 'jquery'
import Splide from '@splidejs/splide'

if ( $('.js-services-slider').length != 0 ) {
    var servicesSplide = new Splide( '.js-services-slider', {
        drag   : 'free',
        arrows: false,
        pagination: false,
        fixedWidth : '275px',
        fixedHeight : '275px',
        gap : '5px',
        destroy: true,
        breakpoints: {
            992: {
                destroy: false,
            },
        }
    } );

    servicesSplide.mount();
}
